import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-drop ml-2",
  style: {"font-size":"6px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!

  return (_openBlock(), _createBlock(_component_dropdown_menu, {
    id: `customer-element-${_ctx.customer.id}`,
    actions: _ctx.actions
  }, {
    trigger: _withCtx(() => [
      _createVNode(_component_outline_button, null, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.actions')), 1),
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "actions"]))
}